/* Dependencies */
import styled from 'styled-components';

/* Components */
import { Button } from 'lego-dist';

export const InputGroup = styled.div.attrs(({ className }) => ({
  className: `StyledMoveDirectorInputGroup ${className}`,
}))`
  display: block;
  margin-bottom: 16px;
  position: relative;

  .legoSelecterContainer {
    border-color: ${({ theme }) => theme.colors.shadeMedium};
    box-shadow: 0 3px 6px 0 #00000020;
  }

  .legoSelecterInput {
    color: #4A4A4A;
    font-size: 16px;
    font-weight: normal;
  }

  .legoSelecterLabel {
    color: ${({ theme }) => theme.colors.shadeMediumDark};
    font-size: 16px;
    font-weight: normal;
    line-height: 28px;
  }

  .legoSelecterCheckbox {
    height: 18px;
    width: 18px;

    border-radius: 3px;
    cursor: pointer;
  }

  .legoSelecterOptionsList .legoSelecterOptionItem {
    display: flex;
    align-items: center;

    height: 36px;
    padding: 0 16px;
  }

  .legoSelecterOptionsList .legoSelecterOptionItem:hover {
    background-color: ${({ theme }) => theme.colors.shadeLight};;
  }

  .legoSelecterOptionsContainer {
    border-color: ${({ theme }) => theme.colors.shadeMedium};
    box-shadow: 0 3px 6px 0 #00000020;
    margin-top: 0;
    max-height: 200px;
    overflow-y: auto;
    padding: 0;
  }

  .legoSelecterOptionIndicator {
    top: 12px;
  }

  .legoSelecterOptionsList {
    margin-top: 0;
  }
`;

export const Wrapper = styled.div.attrs(() => ({
  className: 'MoveDirectorWrapper',
}))`
  display: block;
  padding: 20px 20px 30px 20px;
`;

export const Title = styled.p.attrs(() => ({
  className: 'MoveDirectorTitle',
}))`
  color: ${({ theme }) => theme.colors.shadeDark};
  font-size: 16px;
  font-weight: bold;
  line-height: 23px;

  margin: 0;
  margin-bottom: 20px;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 18px;
  }
`;

export const Label = styled.label.attrs(() => ({
  className: 'StyledMoveDirectorLabel',
}))`
  color: #4A4A4A;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  margin-top: 20px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const WrapperSelecter = styled.div.attrs(() => ({
  className: 'WrapperSelecterMoveDirector',
}))`
  display: block;
  position: relative;
  height: 300px;
  margin-top: 5px;
`;

export const FootWrapper = styled.div.attrs(() => ({
  className: 'MoveDirectorFootWrapper',
}))`
  text-align: right;
`;

export const MoveDirectorBtn = styled(Button).attrs(() => ({
  className: 'MoveDirectorButton',
}))`
  ${({ theme }) => theme.breakPoints.tablet} {
    display: inline-block;
    min-width: 170px;
    max-width: 170px;
    width: 170px;
  }
`;
